import { translateService } from '../service/TranslateService'
import { widgetWrapper } from '../wrapper/WidgetWrapper'
import { on, hash } from "../utils"
class MobileTemplate {
	open = false
	getHtml (languages) {

		return /* html */ `
		<div class="mobile">
			<img  ${on('click', this, 'toogle')} src="../modules/mod_googletranslate/assets/${this.getCurrentLang()}.svg" />
			<svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.5 5L0 0H7L3.5 5Z" fill="white"/>
			</svg>
			<div class="dropdown ${this.open === false ? 'close ' : 'open '} navbar-nav google-translate-wrapper">
				${languages.map(lang => lang.template.getHtml(lang.name, this.getCurrentLang())).join('')}
			</div> 
		</div>	
		`
	}

	toogle () {
		if(this.open == false) this.open = true
		else this.open = false	
		widgetWrapper.render()
	}

	getCurrentLang  () {
		let activelang = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)')
		activelang = activelang ? activelang[2].split('/')[2] : null
		
		if (!activelang)
			activelang = translateService.params.siteLanguage
		return activelang
	}

}

const mobileTemplate = new MobileTemplate()
export {
	MobileTemplate,
	mobileTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/template/MobileTemplate.js